import { POINTS_PER_EURO, POINTS_PER_LEVEL } from "./consts";

export const getLevelFromTotalPoints = (total_points: number): number =>
  Math.floor(total_points / POINTS_PER_LEVEL) + 1;

export const estimatedValue2points = (value: number): number =>
  value * POINTS_PER_EURO;
